// STATUS REUNIÃO
export const colorProxima = "rgba(153, 255, 205, 0.5)"
export const colorEmAndamento = "rgba(92, 153, 255, 0.5)"
export const colorRealizada = "rgba(255, 100, 90, 0.5)"

// STATUS PARTICIPANTE
export const colorPresente = "rgba(16, 179, 16, 0.5)"
export const colorInscrito = "rgba(0, 127, 255, 0.5)"
export const colorSaiu = "rgba(255, 0, 0, 0.5)"
export const colorAusente = "rgba(122, 122, 122, 0.5)"
export const colorPendenteInscricao = "rgba(222, 241, 48, 0.5)"
